"use client";
import { useRouter } from "../../../navigation";
import useCurrentUser from "../../auth/hooks/useCurrentUser";
import Button from "../../theme/components/Button";
import { useTranslations } from "next-intl";

interface AvatarButtonProps {
  showText?: boolean;
  className?: string;
  iconName?: string;
}

const AvatarButton = ({
  showText = false,
  className = "",
  iconName = "avatar",
}: AvatarButtonProps) => {
  const { currentUser } = useCurrentUser();
  const router = useRouter();
  const t = useTranslations();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (currentUser) {
      router.push("/portal");
    } else {
      router.push("/login");
    }
  };

  return (
    <Button
      onClick={handleClick}
      appearance="link"
      icon={iconName}
      iconPosition={showText ? "right" : "left"}
      className={
        showText
          ? `d-flex align-items-center ${className}`
          : `justify-content-start text-start ${className}`
      }
      aria-label={currentUser ? t("go_to_portal") : t("login")}
      style={{
        minWidth: "42px",
        minHeight: "42px",
      }}
    >
      {showText && t("my_publicare")}
    </Button>
  );
};

export default AvatarButton;
